import { PUBLIC_PAGE_SEO } from './seoConfig';

/** Indexable marketing routes that must render without any backend/API dependency. */
export const PUBLIC_MARKETING_PATHS = PUBLIC_PAGE_SEO.map((page) => page.path);

export function isPublicMarketingPath(pathname = window.location.pathname): boolean {
  const normalized =
    pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
  return PUBLIC_MARKETING_PATHS.includes(normalized);
}
